document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Product image thumbnail swap
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var newSrc = thumb.getAttribute('data-image');
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
      }
    });
  });
});
